// Global Application State with Change Notifications
class Store {
  constructor(initialState) {
    this.state = initialState;
    this.listeners = [];
  }

  subscribe(listener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }

  setState(newState) {
    const prevState = { ...this.state };
    this.state = { ...this.state, ...newState };
    
    // Notify listeners of state changes
    this.listeners.forEach(listener => listener(this.state, prevState));
  }
  
  getState() {
    return { ...this.state };
  }
}

// Initialize the store with the original state
export const appState = new Store({
  user: null,
  userData: null,
  isAdmin: false,
  isLoading: true
});